import { useParams } from 'react-router-dom'

import * as service from 'service'

import { useFetch } from 'hooks'

import DaiOptOutContext from 'contexts/DaiOptOutContext'

const DaiOptOutProvider = ({ children }) => {
  const { organizationId, companyId } = useParams()

  const isCompany = !!companyId

  const idParam = isCompany
    ? { companyId: String(companyId) }
    : { organizationId: String(organizationId) }

  const getFn = isCompany
    ? service.backoffice.daiOptOuts.getCompany
    : service.backoffice.daiOptOuts.getOrganization

  const manageFn = isCompany
    ? service.backoffice.daiOptOuts.manageCompany
    : service.backoffice.daiOptOuts.manageOrganization

  const { response, isLoading, refresh } = useFetch(
    getFn,
    {
      ...idParam,
    },
    [organizationId, companyId],
    !!organizationId || !!companyId,
  )

  const daiOptOut = response?.data?.daiOptOut

  const manage = async (payload) => {
    await manageFn({ ...idParam, daiOptOut: payload })
  }

  return (
    <DaiOptOutContext.Provider
      value={{ daiOptOut, isLoading, refresh, manage }}
    >
      {children}
    </DaiOptOutContext.Provider>
  )
}

export default DaiOptOutProvider
